"use client";

import Link from "next/link";
import { FaCalendar, FaEye } from "react-icons/fa";

export interface ColumnCardProps {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  thumbnail_url: string;
  category: string;
  published_at: string | null;
  view_count: number;
  is_featured: boolean;
}

export default function ColumnCard({
  title,
  slug,
  excerpt,
  thumbnail_url,
  category,
  published_at,
  view_count,
  is_featured,
}: ColumnCardProps) {
  const formatDate = (dateStr: string | null) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("ja-JP", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <Link
      href={`/columns/${slug}`}
      className="bg-white rounded-2xl border border-[#32291f]/10 overflow-hidden hover:shadow-lg transition-all duration-300 group flex flex-col h-full"
    >
      {thumbnail_url ? (
        <div className="aspect-video overflow-hidden">
          <img
            src={thumbnail_url}
            alt={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      ) : (
        <div className="aspect-video bg-gradient-to-br from-[#f09819]/20 to-[#ff512f]/20 flex items-center justify-center">
          <span className="text-2xl text-[#ed7243] font-bold">TrueMee</span>
        </div>
      )}
      <div className="p-5 flex-1 flex flex-col">
        <div className="flex flex-wrap gap-2 mb-3">
          {category && (
            <span className="inline-block px-3 py-1 bg-[#ed7243] text-white text-xs rounded font-medium">
              {category}
            </span>
          )}
          {is_featured && (
            <span className="inline-block px-3 py-1 bg-gradient-to-r from-[#f09819] to-[#ff512f] text-white text-xs rounded font-medium">
              おすすめ
            </span>
          )}
        </div>
        <h3 className="text-[#32291f] text-base font-bold mb-2 group-hover:text-[#ed7243] line-clamp-2 flex-grow leading-relaxed">
          {title}
        </h3>
        {excerpt && (
          <p className="text-[#32291f]/70 text-sm mb-3 line-clamp-2 leading-relaxed">{excerpt}</p>
        )}
        <div className="flex items-center gap-4 text-xs text-[#32291f]/50 mt-auto pt-3 border-t border-[#32291f]/10">
          <span className="flex items-center gap-1">
            <FaCalendar className="text-[#ed7243]" />
            {formatDate(published_at)}
          </span>
          <span className="flex items-center gap-1">
            <FaEye className="text-[#ed7243]" />
            {view_count.toLocaleString()}
          </span>
        </div>
      </div>
    </Link>
  );
}
